export default __webpack_public_path__ + "static/logo-8-4e2a95c873936158394358442a4575a7.png";